<template>
    <div>
        <main class="flex flex-col overflow-scroll border-gray-200 border rounded-2xl px-2 py-4 bg-white" :key="key">
            <div class="ml-2 flex" v-if="user == null">
                Loading user data....
            </div>
            <div class="mx-2" v-else>
                <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">
                    <div v-if="isActive('overview')">
                        <div class="grid gap-6 grid-cols-12 pb-6 pt-0">
                            <div class="col-span-12">
                                <label for="field-name"
                                       class="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                <div class="flex">
                                    <ui-input name="name" v-model="user.name" placeholder="Full name..."
                                              class="flex-1" @change="save"></ui-input>
                                </div>
                            </div>
                            <ui-input-file-inline label="Avatar Image"
                                                  name="avatar"
                                                  class="col-span-12"
                                                  :max-filesize="1048576"
                                                  :filesystemId="user.filesystemId"
                                                  :single="true"
                                                  :noFileList="true"
                                                  :attachUrl="attachUrl"
                                                  :downloadUrl="downloadUrl"
                                                  :current-files="getAvatarFiles"></ui-input-file-inline>
                            <ui-toggle label="Use my Avatar when sending emails" v-model="user.sendAvatarOnEmail"
                                       @input="save"></ui-toggle>
                        </div>
                    </div>
                    <div v-if="isActive('security')">
                        <div class="grid gap-6 grid-cols-12 py-0">
                            <div class="xl:col-span-6 col-span-12">
                                <label for="field-name"
                                       class="block text-sm font-medium text-gray-700 mb-2">Email Addresses</label>
                                <div
                                    class="flex border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold ">
                                    <div class="flex-1 border-l border-gray-200 px-2 py-1">Email Address</div>
                                    <div class="w-72 border-l border-gray-200 px-2 py-1">Status</div>
                                    <div class="w-6 border-l border-gray-200 flex-shrink-0"></div>
                                </div>
                                <div class="flex -mt-px border-t border-b border-gray-200 bg-white"
                                     v-for="email in emails">
                                    <div
                                        class="flex-1 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                        <div class="text-gray-600 w-full truncate">{{ email.value }}</div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Requested
                                            {{ moment(email.requested).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div
                                        class="w-72 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1"
                                        v-if="email.status=='valid'">
                                        <div class="text-gray-600 w-full truncate text-green-600">Valid</div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Validated
                                            {{ moment(email.validated).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div
                                        class="w-72 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1"
                                        v-else-if="email.status=='expired'">
                                        <div class="text-gray-600 w-full truncate text-red-600">Request Expired</div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Expired
                                            {{ moment(email.expires).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div
                                        class="w-72 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1"
                                        v-else-if="email.status=='pending'">
                                        <div class="text-gray-600 w-full truncate text-orange-600">Pending Validation
                                        </div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Expires
                                            {{ moment(email.expires).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div class="w-6 border-l border-gray-200 flex-shrink-0 ">
                                        <ui-dropdown menu-class="p-3 w-72">
                                            <template #default="{ toggle }">
                                                <button @click="toggle"
                                                        class="w-3 h-3 mt-3 ml-1 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                                    <i class="fa fa-ellipsis-h"></i>
                                                </button>
                                            </template>
                                            <template #menu="{ close }">
                                                <ui-dropdown-item icon="fas fa-link" v-if="email.status=='pending'"
                                                                  @click="validate(email.value);close()">
                                                    Enter Validation Code
                                                </ui-dropdown-item>
                                                <ui-dropdown-item icon="fas fa-link" v-if="email.status=='expired'"
                                                                  @click="rerequest(email.value);close()">
                                                    Re-request Email Address
                                                </ui-dropdown-item>
                                                <ui-dropdown-divider
                                                    v-if="(email.status=='pending') || (email.status=='expired')"/>
                                                <ui-dropdown-item icon="fas fa-trash" danger
                                                                  @click="removeHandle(email);close()">
                                                    Remove Email Address
                                                </ui-dropdown-item>
                                            </template>
                                        </ui-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="xl:col-span-6 col-span-12">
                                <label for="field-name"
                                       class="block text-sm font-medium text-gray-700 mb-2">Phone Numbers</label>
                                <div
                                    class="flex border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold ">
                                    <div class="flex-1 border-l border-gray-200 px-2 py-1">Phone Number</div>
                                    <div class="w-72 border-l border-gray-200 px-2 py-1">Status</div>
                                    <div class="w-6 border-l border-gray-200 flex-shrink-0"></div>
                                </div>
                                <div class="flex -mt-px border-t border-b border-gray-200 bg-white"
                                     v-for="phoneNumber in phoneNumbers">
                                    <div
                                        class="flex-1 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                        <div class="text-gray-600 w-full truncate">{{ phoneNumber.value }}</div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Requested
                                            {{ moment(phoneNumber.requested).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div
                                        class="w-72 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1"
                                        v-if="phoneNumber.status=='valid'">
                                        <div class="text-gray-600 w-full truncate text-green-600">Valid</div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Validated
                                            {{ moment(phoneNumber.validated).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div
                                        class="w-72 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1"
                                        v-else-if="phoneNumber.status=='expired'">
                                        <div class="text-gray-600 w-full truncate text-red-600">Request Expired</div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Expired
                                            {{ moment(phoneNumber.expires).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div
                                        class="w-72 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1"
                                        v-else-if="phoneNumber.status=='pending'">
                                        <div class="text-gray-600 w-full truncate text-orange-600">Pending Validation
                                        </div>
                                        <div class="text-xs text-gray-400 mt-0 truncate">Expires
                                            {{ moment(phoneNumber.expires).format('Do MMMM YYYY, h:mm a') }}
                                        </div>
                                    </div>
                                    <div class="w-6 border-l border-gray-200 flex-shrink-0 ">
                                        <ui-dropdown menu-class="p-3 w-72">
                                            <template #default="{ toggle }">
                                                <button @click="toggle"
                                                        class="w-3 h-3 mt-3 ml-1 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                                    <i class="fa fa-ellipsis-h"></i>
                                                </button>
                                            </template>
                                            <template #menu="{ close }">
                                                <ui-dropdown-item icon="fas fa-link"
                                                                  v-if="phoneNumber.status=='pending'"
                                                                  @click="validate(phoneNumber.value);close()">
                                                    Enter Validation Code
                                                </ui-dropdown-item>
                                                <ui-dropdown-item icon="fas fa-link"
                                                                  v-if="phoneNumber.status=='expired'"
                                                                  @click="rerequest(phoneNumber.value);close()">
                                                    Re-request Phone Number
                                                </ui-dropdown-item>
                                                <ui-dropdown-divider
                                                    v-if="(phoneNumber.status=='pending') || (phoneNumber.status=='expired')"/>
                                                <ui-dropdown-item icon="fas fa-trash" danger
                                                                  @click="removeHandle(phoneNumber);close()">
                                                    Remove Phone Number
                                                </ui-dropdown-item>
                                            </template>
                                        </ui-dropdown>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="flex mt-2 mb-5 w-full ml-4">
                            <div class="flex-1">
                                <ui-button-new class="items-baseline" icon="fas fa-plus" @click="addHandle" small
                                               secondary>Add
                                    new Email Address or Phone Number
                                </ui-button-new>
                            </div>
                        </div>
                        <div class="col-span-12 flex items-center justify-center mt-4">
                            <div class="flex">
                                <ui-button-new class="items-baseline w-64 ml-2" icon="fas fa-passport"
                                               @click="updatePassword"
                                               primary>Change your Login Password
                                </ui-button-new>
                            </div>
                        </div>
                    </div>
                    <div v-if="isActive('organization')">
                        <label for="field-name"
                               class="block text-sm font-medium text-gray-700 mb-2">Organization Membership</label>
                        <div
                            class="flex border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold ">
                            <div class="w-96 border-l border-gray-200 px-2 py-1">Organization Name</div>
                            <div class="flex-1 border-l border-gray-200 px-2 py-1">URL</div>
                            <div class="w-6 border-l border-gray-200 flex-shrink-0"></div>
                        </div>
                        <div class="flex -mt-px border-t border-b border-gray-200 bg-white"
                             v-for="org in user.memberOf">
                            <div class="w-96 border-l border-gray-200 px-2 py-1 truncate">
                                <div class="text-gray-600 w-full truncate">{{ org.name }}</div>
                                <div class="text-xs text-gray-400 mt-0">Member since : 21st September 2023 - 12:12pm
                                </div>
                            </div>
                            <div
                                class="flex-1 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                <div class="text-gray-600 w-full truncate">{{ org.url }}</div>
                            </div>
                            <div class="w-6 border-l border-gray-200 flex-shrink-0 "></div>
                        </div>
                        <div class="col-span-12 flex items-center justify-center mt-4">
                            <div class="flex">
                                <ui-button-new class="items-baseline w-64 ml-2" icon="fas fa-sign-out"
                                               primary>Create new Organization
                                </ui-button-new>
                            </div>
                        </div>
                    </div>
                    <div v-if="isActive('notification')">
                        <label for="field-name"
                               class="block text-sm font-medium text-gray-700 mb-2 text-red-400">Notification Settings (currently disabled - alpha)</label>
                        <div
                            class="flex border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold ">
                            <div class="flex-1 border-l border-gray-200 px-2 py-1">Condition</div>
                            <div class="w-48 border-l border-gray-200 px-2 py-1">Send me an Email</div>
                            <div class="w-48 border-l border-gray-200 px-2 py-1">Send me a SMS</div>
                            <div class="w-6 border-l border-gray-200 flex-shrink-0"></div>
                        </div>
                        <div class="flex -mt-px border-t border-b border-gray-200 bg-white">
                            <div class="flex-1 border-l border-gray-200 px-2 py-1 truncate">
                                <div class="text-gray-600 w-full truncate">When a message is received from someone that is a member of an organization you belong to</div>
                            </div>
                            <div
                                class="w-48 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                <ui-toggle v-model="user.q" @input="save"></ui-toggle>
                            </div>
                            <div
                                class="w-48 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                <ui-toggle v-model="user.q" @input="save"></ui-toggle>
                            </div>
                            <div class="w-6 border-l border-gray-200 flex-shrink-0 "></div>
                        </div>
                        <div class="flex -mt-px border-t border-b border-gray-200 bg-white">
                            <div class="flex-1 border-l border-gray-200 px-2 py-1 truncate">
                                <div class="text-gray-600 w-full truncate">When a message is received from someone that is NOT a member of an organization you belong to</div>
                            </div>
                            <div
                                class="w-48 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                <ui-toggle v-model="user.q" @input="save"></ui-toggle>
                            </div>
                            <div
                                class="w-48 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                <ui-toggle v-model="user.q" @input="save"></ui-toggle>
                            </div>
                            <div class="w-6 border-l border-gray-200 flex-shrink-0 "></div>
                        </div>

                        <div class="flex -mt-px border-t border-b border-gray-200 bg-white">
                            <div class="flex-1 border-l border-gray-200 px-2 py-1 truncate">
                                <div class="text-gray-600 w-full truncate">When an "actionable" message you have sent has been actioned</div>
                            </div>
                            <div
                                class="w-48 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                <ui-toggle v-model="user.q" @input="save"></ui-toggle>
                            </div>
                            <div
                                class="w-48 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 px-2 py-1">
                                <ui-toggle v-model="user.q" @input="save"></ui-toggle>
                            </div>
                            <div class="w-6 border-l border-gray-200 flex-shrink-0 "></div>
                        </div>

                    </div>
                </ui-tabs>
            </div>
        </main>
    </div>
</template>

<script>
import User from "../../services/User";
import UiButton from "../ui/UiButton.vue";
import UiInput from "../ui/UiInput.vue";
import UiDatePicker from "../ui/UiDatePicker.vue";
import UiInputFile from "../ui/UiInputFile.vue";
import OrganizationPermissionLine from "../organization/OrganizationPermissionLine.vue";
import moment from "moment";
import UiDropdown from "../ui/UiDropdown.vue";
import UiInputFileInline from "../filesystem/inline/UiInputFileInline.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiToggle from "../ui/UiToggle.vue";
import UiTabs from "../ui/UiTabs.vue";

export default {
    components: {
        UiTabs,
        UiToggle,
        UiButtonNew,
        UiInputFileInline,
        UiDropdown,
        OrganizationPermissionLine,
        UiInputFile,
        UiDatePicker,
        UiInput,
        UiButton
    },
    props: [],
    data() {
        return {
            user: null,
            key: 0,
            phoneNumbers: [],
            emails: [],
            fileId: null,
            tabs: [
                {value: 'overview', label: 'User Details'},
                {value: 'security', label: 'Authentication'},
                {value: 'organization', label: 'Organizations'},
                {value: 'notification', label: 'Notifications'},
            ],

        }
    },
    watch: {
        user: {
            handler(newValue, oldValue) {
            },
            deep: true,
        },
    },
    computed: {
        moment() {
            return moment
        }
    },
    methods: {
        updatePassword() {
            this.$modals.open('user-profile-update-password', {
                title: `Change your Login Password`,
                handle: async (data, modal) => {
                    modal.close();
                    setTimeout(() => {
                        this.$modals.info({
                            title: `Success!`,
                            paragraphs: ['Your password has been updated successfully.'],
                        })
                    }, 200)
                }
            })
        },
        attachUrl(id) {
            this.fileId = id;
            return route('api.v2.organization.user.profile.avatar.attach', [id])
        },
        downloadUrl() {
            return this.user.avatarUrl
        },
        async getAvatarFiles() {
            await User.refresh()
            this.user = User.user;
            return this.user.avatarUrl ? [{'id': this.fileId, 'thumbnail': this.user.avatarUrl + '?t=t'}] : []
        },
        async logout() {
        },
        async save() {
            await Http.put(route('api.v2.organization.user.update'), {
                name: this.user.name,
                sendAvatarOnEmail: this.user.sendAvatarOnEmail
            })
        },
        updateUserFromListener(event) {
            this.user = User.user;
            this.calculateHandles()
        },
        addHandle() {
            this.$modals.open('user-profile-add-handle', {
                title: `Add a new Email Address or Phone Number to your account`,
                button: 'Send Authentication Code',
                handle: async (data, modal) => {
                    modal.close();
                }
            })
        },
        rerequest(value) {
            this.$modals.open('user-profile-add-handle', {
                title: `Add a new Email Address or Phone Number to your account`,
                button: 'Send Authentication Code',
                value: value,
                handle: async (data, modal) => {
                    modal.close();
                }
            })
        },
        validate(value) {
            this.$modals.open('user-profile-add-handle', {
                title: `Add a new Email Address or Phone Number to your account`,
                button: 'Send Authentication Code',
                value: value,
                goValidate: true,
                handle: async (data, modal) => {
                    modal.close();
                }
            })
        },
        async removeHandle(handle) {
            if (handle.status === 'valid') {
                this.$modals.confirmDelete({
                    title: `Remove ${handle.value}?`,
                    button: 'Yes, remove this handle',
                    handle: async () => {
                        try {
                            await Http.delete(route('api.v2.organization.user.handle.remove', [handle.value]))
                        } catch (error) {
                            let body = JSON.parse(error.request.response);
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    this.$modals.error(
                                        {
                                            title: `Cannot remove ${handle.value}`,
                                            paragraphs: ['This handle cannot be removed', body.message]
                                        },
                                    )
                                })
                            }, 200)
                        }
                    }
                })
            } else {
                await Http.delete(route('api.v2.organization.user.handle.remove', [handle.value]))
            }
        },
        calculateHandles() {
            let emails = {}
            let phoneNumbers = {}
            this.user.requestedHandles.forEach(handle => {
                if (handle.type === "emailAddress") {
                    emails[handle.value] = {
                        value: handle.value,
                        requested: handle.created,
                        validated: null,
                        status: (moment() > moment(handle.expires)) ? 'expired' : 'pending',
                        expires: moment(handle.expires)
                    };
                } else {
                    phoneNumbers[handle.value] = {
                        value: handle.value,
                        requested: handle.created,
                        validated: null,
                        status: (moment() > moment(handle.expires)) ? 'expired' : 'pending',
                        expires: moment(handle.expires)
                    };
                }
            })
            this.user.handles.forEach(handle => {
                if (handle.type === "emailAddress") {
                    if (emails[handle.value]) {
                        emails[handle.value].validated = handle.created;
                        emails[handle.value].status = 'valid';
                    } else {
                        emails[handle.value] = {
                            value: handle.value,
                            requested: handle.created,
                            validated: handle.created,
                            status: 'valid'
                        };
                    }
                } else {
                    if (phoneNumbers[handle.value]) {
                        phoneNumbers[handle.value].validated = handle.created;
                        phoneNumbers[handle.value].status = 'valid';
                    } else {
                        phoneNumbers[handle.value] = {
                            value: handle.value,
                            requested: handle.created,
                            validated: handle.created,
                            status: 'valid'
                        };
                    }
                }
            })
            this.phoneNumbers = Object.values(phoneNumbers);
            this.emails = Object.values(emails);
        }
    },
    async mounted() {
        await User.register();
        this.user = User.user;
        User.registerAggregate({"type": 'User', 'id': this.user.id}, this.updateUserFromListener)
        this.calculateHandles();
        this.fileId = this.user.id;
    }
}
</script>
